import clsx from "clsx";
import { ApplicationEventType } from "models/types";
import { AnalysisStatusLabel, RedirectApplicationStatusLabel } from "services/types";

const POSITIVE_STYLE = "bg-feedback-positive-high-50 text-feedback-positive-low-950";
const NEUTRAL_STYLE = "bg-feedback-alert-high-50 text-feedback-alert-low-950";
const NEGATIVE_STYLE = "bg-feedback-negative-high-50 text-feedback-negative-low-950";

export const statusStyles: Record<AnalysisStatusLabel | RedirectApplicationStatusLabel, string> = {
	[AnalysisStatusLabel.EM_ANDAMENTO]: NEUTRAL_STYLE,
	[AnalysisStatusLabel.APROVADO]: POSITIVE_STYLE,
	[AnalysisStatusLabel.REPROVADO]: NEGATIVE_STYLE,
	[AnalysisStatusLabel.CANCELADO]: NEGATIVE_STYLE,
	[AnalysisStatusLabel.SOLICITADA_ALTERACAO]: NEUTRAL_STYLE,
	[RedirectApplicationStatusLabel.DEVOLVIDO]: NEUTRAL_STYLE
};

export const eventTypes: Record<ApplicationEventType, string> = {
	[ApplicationEventType.SOLICITACAO_CRIADA]: NEUTRAL_STYLE,
	[ApplicationEventType.ASSUMIR_RESPONSABILIDADE]: NEUTRAL_STYLE,
	[ApplicationEventType.REMOVER_RESPONSABILIDADE]: NEUTRAL_STYLE,
	[ApplicationEventType.ADICIONAR_COMENTARIO]: NEUTRAL_STYLE,
	[ApplicationEventType.SOLICITAR_ALTERACAO]: NEUTRAL_STYLE,
	[ApplicationEventType.DEVOLUTIVA_DO_SOLICITANTE]: POSITIVE_STYLE,
	[ApplicationEventType.SOLICITACAO_CANCELADA]: NEGATIVE_STYLE,
	[ApplicationEventType.SOLICITACAO_APROVADA]: POSITIVE_STYLE,
	[ApplicationEventType.SOLICITACAO_REPROVADA]: NEGATIVE_STYLE,
	[ApplicationEventType.RESPOSTA_INTERESSADO]: NEUTRAL_STYLE,
	[ApplicationEventType.SOLICITAR_CANCELAMENTO]: NEUTRAL_STYLE,
	[ApplicationEventType.APROVAR_CANCELAMENTO]: NEGATIVE_STYLE,
	[ApplicationEventType.REJEITAR_CANCELAMENTO]: NEUTRAL_STYLE
};

export const eventStatusLabels: Record<ApplicationEventType, string> = {
	[ApplicationEventType.SOLICITACAO_CRIADA]: AnalysisStatusLabel.EM_ANDAMENTO,
	[ApplicationEventType.ASSUMIR_RESPONSABILIDADE]: AnalysisStatusLabel.EM_ANDAMENTO,
	[ApplicationEventType.REMOVER_RESPONSABILIDADE]: AnalysisStatusLabel.EM_ANDAMENTO,
	[ApplicationEventType.ADICIONAR_COMENTARIO]: AnalysisStatusLabel.EM_ANDAMENTO,
	[ApplicationEventType.SOLICITAR_ALTERACAO]: AnalysisStatusLabel.SOLICITADA_ALTERACAO,
	[ApplicationEventType.DEVOLUTIVA_DO_SOLICITANTE]: AnalysisStatusLabel.EM_ANDAMENTO,
	[ApplicationEventType.SOLICITACAO_CANCELADA]: AnalysisStatusLabel.CANCELADO,
	[ApplicationEventType.SOLICITACAO_APROVADA]: AnalysisStatusLabel.APROVADO,
	[ApplicationEventType.SOLICITACAO_REPROVADA]: AnalysisStatusLabel.REPROVADO,
	[ApplicationEventType.RESPOSTA_INTERESSADO]: AnalysisStatusLabel.EM_ANDAMENTO,
	[ApplicationEventType.SOLICITAR_CANCELAMENTO]: AnalysisStatusLabel.EM_ANDAMENTO,
	[ApplicationEventType.APROVAR_CANCELAMENTO]: AnalysisStatusLabel.CANCELADO,
	[ApplicationEventType.REJEITAR_CANCELAMENTO]: AnalysisStatusLabel.EM_ANDAMENTO
};

export default function StatusTag({
	status,
	eventType,
	small,
	className = ""
}: Readonly<{
	status: AnalysisStatusLabel | RedirectApplicationStatusLabel;
	eventType?: ApplicationEventType;
	small?: boolean;
	className?: string;
}>): JSX.Element {
	return (
		<div
			className={clsx(
				className,
				eventType ? eventTypes[eventType] : statusStyles[status],
				small ? "px-2 sm:min-h-6 py-1 text-xs" : "px-3 sm:h-10 py-2 text-sm",
				"flex items-center text-center font-semibold rounded-lg"
			)}
		>
			{eventType ? eventStatusLabels[eventType] : status}
		</div>
	);
}
